exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.empty {\n    font-family: GlacialIndifference-Bold;\n    font-size: large;\n    color: var(--teal);\n    padding-top: 100px;\n    padding-bottom: 100px;\n}\n\n.trainer {\n    width: 100%;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 10px;\n    border: #eaeaea;\n    border-width: 0px 0px 1px 0px;\n    border-style: solid;\n    align-items: center;\n    display: flex;\n    flex-direction: row;\n}", ""]);

// exports
